import type { IMapPlaceDto, SimpleResult } from "../dto";
import { Api } from "../helpers";
import type { ICoordinate, SupportedLanguage } from "../models";

export class MapPlacesApi {
  /** What is at a point, looked up on the company's `geocodingService`; `null` data means no address there. */
  static async findByCoordinate({
    companyId,
    coordinate,
    languageCode,
    abortController,
  }: {
    companyId: number;
    coordinate: ICoordinate;
    languageCode: SupportedLanguage;
    abortController?: AbortController;
  }): Promise<SimpleResult<IMapPlaceDto | null> | undefined> {
    const requestUrl = `/api/v1/core/c/${companyId}/map-places/find-by-coordinate`;
    const response = await Api.get<SimpleResult<IMapPlaceDto | null>>(
      requestUrl,
      { lat: coordinate.lat, lng: coordinate.lng, languageCode },
      abortController,
    );

    return response?.data;
  }
}
